import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";

import config from '../../config/config';
import ListMessageThreads from './ListMessageThreads';
import SelectPatientForm from '../scheduling/SelectPatientForm';
import useIsMobile from "../../hooks/useIsMobile";

const ListMessagesScreen = props => {
  const isMobile = useIsMobile();
  const {user, messages} = props;
  return (
    <Stack direction='row' spacing={2} fullWidth={true}>
      <Dialog
        fullWidth={true}
        maxWidth='sm'
        open={!props.isPatient && props.scheduleDialogIsOpen}
        onClose={() => props.setScheduleDialogIsOpen(false)}
      >
        <SelectPatientForm messagePageAccess={true}/>
      </Dialog>
      <Stack sx={{width: '100%'}}>
        <Stack direction='row' justifyContent={'space-between'} sx={{
          color: config().colors.secondary,
          padding: { xs: '0 0 0 14px', sm: '0 0 14px 0' },
          margin: { xs: '4px 0 10px', sm: '4px 0' },
        }}>
          <Stack direction='row' alignItems='center'>
            <EditCalendarOutlinedIcon sx={{width: '24px', marginRight: '9px', height: '24px'}}/>
            <Typography variant={'normalSemiBoldInter'}>
              {props.unreadCount} unread
            </Typography>
          </Stack>
          {
            !props.isPatient
              ? <Button
                size='large'
                variant='primaryGradient'
                onClick={() => props.setScheduleDialogIsOpen(true)}
              >
                <Typography variant={isMobile ? 'small500xTight' : 'large'}>New Message</Typography>
              </Button>
              : null
          }
        </Stack>
        <Stack spacing={4} justifyContent='center'>
          <Typography variant='h2' align='center'>
            Unread Messages
          </Typography>
          {props?.unreadMessages && props.unreadMessages?.length
            ? <div><ListMessageThreads user={user} messages={props.unreadMessages}/></div>
            : <Typography variant='h3' align='center' color='gray' padding={3}>
                🎉 No Unread Messages!
            </Typography>
          }
          <Typography variant='h2' align='center'>
            Read Messages
          </Typography>
          {props?.messages && props.messages.length
            ? <div><ListMessageThreads user={user} messages={messages}/></div>
            : null
          }
        </Stack>
      </Stack>
    </Stack>
  );
};

ListMessagesScreen.propTypes = {
  user: PropTypes.object,
  messages: PropTypes.arrayOf(PropTypes.object),
  unreadCount: PropTypes.number,
};

export default ListMessagesScreen;
